module.exports = __webpack_public_path__ + "img/zhibao.e464630f.png";